import {axios} from "~/plugins/axios";

const getDefaultState_Tariffs = () => {
  return {
    packageTypes: [],
  }
}
const state = getDefaultState_Tariffs();

const getters = {
  packageTypes: state => state.packageTypes,
}

const actions = {
  async loadPackageTypes({commit}) {
    commit('shared/SET_LOADING', true, {root: true})

    await axios.get('/api/tariffication/package-types')
      .then(response => {
        commit('SET_PACKAGE_TYPES', response.data.data);
      }).catch(error => {
        commit('shared/SET_ERROR', error.response.data, {root: true});

        throw error;
      });

    commit('shared/SET_LOADING', false, {root: true});
  },
}

const mutations = {
  SET_PACKAGE_TYPES(state, payload) {
      state.packageTypes = payload;
  },


  RESET_STATE_TARIFFS (state) {
    Object.assign(state, getDefaultState_Tariffs())
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
